import React from "react";

export default () => {

  return <>
  <div className="iconHolder">
    <img
      alt="headingLogo"
      src="/_resources/themes/las/dist/img/headingLogo.svg"
    />
    </div>
  </>

}
